import { AUTH_ROLES } from "api/common/types/auth.types";
import { ProficiencyFeedback } from "api/memberPortal/proficiencyFeedback/proficiencyFeedback.types";
import { Product } from "api/memberPortal/project/product/product.types";
import {
  PRODUCT_KICKOFF_STATUSES,
  PRODUCT_STATUSES,
} from "api/memberPortal/project/product/productStatuses.type";
import { AppPermission } from "app/role.types";

const canCreateProficiencyFeedbackForm = (
  product: Product,
  permissions: AppPermission,
  isSubmitted: boolean,
) => {
  const isEligibleProduct =
    product.kickoff_status === PRODUCT_KICKOFF_STATUSES.KICKED_OFF ||
    product.status === PRODUCT_STATUSES.WITHDRAWN;

  const isValidator = permissions.role_type === AUTH_ROLES.VALIDATOR;
  return isEligibleProduct && isValidator && !isSubmitted;
};

const canViewProficiencyFeedbackForm = (
  feedbackForm: ProficiencyFeedback,
  permissions: AppPermission,
  isSubmitted: boolean,
) => {
  const isNiap = permissions.role_type === AUTH_ROLES.NIAP;

  return isSubmitted && isNiap && feedbackForm;
};

const canViewFeedbackButton = (permissions: AppPermission): boolean => {
  return (
    permissions.role_type === AUTH_ROLES.VALIDATOR ||
    permissions.role_type === AUTH_ROLES.NIAP
  );
};
export {
  canCreateProficiencyFeedbackForm,
  canViewFeedbackButton,
  canViewProficiencyFeedbackForm,
};
